package com.patronat.top

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.*
import com.arkivanov.decompose.extensions.compose.stack.Children
import com.arkivanov.decompose.extensions.compose.stack.animation.slide
import com.arkivanov.decompose.extensions.compose.stack.animation.stackAnimation
import com.patronat.top.core.di.clientCoreModule
import com.patronat.top.core.presentation.AlertController
import com.patronat.top.core.presentation.NotificationType
import com.patronat.top.di.RootComponentFactory
import com.patronat.top.di.rootModule
import com.patronat.top.features.auth.di.authFeatureModule
import com.patronat.top.features.auth.presentation.AuthEffect
import com.patronat.top.features.auth.presentation.AuthViewModel
import com.patronat.top.features.auth.presentation.ui.AuthScreen
import com.patronat.top.features.dashboard.di.dashboardModule
import com.patronat.top.features.dashboard.presentation.ui.MainScreen
import com.patronat.top.features.usermanagement.di.userManagementRepository
import com.patronat.top.features.venues.di.venuesFeatureModule
import com.patronat.top.library.media.di.mediaModule
import com.patronat.top.root.DefaultRootComponent
import com.patronat.top.ui.molecules.alerts.AlertUiModel
import com.patronat.top.ui.molecules.alerts.GlobalAlertOverlay
import com.patronat.top.ui.theme.AppIcons
import com.patronat.top.utils.rememberRetainedComponent
import org.koin.compose.KoinApplication
import org.koin.compose.koinInject

@Composable
fun App() {
    KoinApplication(application = {
        modules(
            clientCoreModule,
            authFeatureModule,
            rootModule,
            dashboardModule,
            userManagementRepository,
            venuesFeatureModule,
            mediaModule
        )
    }) {
        MaterialTheme {
            val alertController: AlertController = koinInject()
            val notificationState by alertController.notification.collectAsState()
            val warningIcon = AppIcons.AlertWarning

            val currentNote = notificationState

            val uiAlertData = if (currentNote != null) {
                AlertUiModel(
                    title = currentNote.title.asString(),
                    message = currentNote.message.asString(),
                    icon = when (currentNote.type) {
                        NotificationType.ERROR -> warningIcon
                        NotificationType.WARNING -> warningIcon
                        NotificationType.SUCCESS -> warningIcon
                    }
                )
            } else {
                null
            }


            val rootFactory: RootComponentFactory = koinInject()

            val rootComponent = rememberRetainedComponent { context ->
                rootFactory(context)
            }

            GlobalAlertOverlay(alertData = uiAlertData) {
                RootContent(component = rootComponent)
            }
        }
    }
}

@Composable
fun RootContent(component: DefaultRootComponent) {
    Children(
        stack = component.childStack,
        animation = stackAnimation(slide())
    ) { child ->
        when (val instance = child.instance) {

            is DefaultRootComponent.Child.Auth -> {
                val viewModel = koinInject<AuthViewModel>()

                LaunchedEffect(Unit) {
                    viewModel.effect.collect { effect ->
                        println("DEBUG: UI спіймав ефект: $effect")
                        when (effect) {
                            is AuthEffect.NavigateToHome -> {
                                instance.component.onLoginClicked(effect.role)
                            }
                            is AuthEffect.ShowToast -> {
                                println("Toast: ${effect.message}")
                            }
                        }
                    }
                }

                AuthScreen(
                    viewModel = viewModel,
                    onNavigateBack = {
                    }
                )
            }

            is DefaultRootComponent.Child.Main -> {
                MainScreen(
                    component = instance.component,
                    userRole = instance.component.userRole
                )
            }

            else -> {}
        }
    }
}
